export const interactionsList = {
  filledRectang: [
    { name: 'removeFilledRectangle' },
    { name: 'resizeFilledRectangle' },
    { name: 'dragFilledRectangle' },
    { name: 'selectFilledRectangle' },
    { name: 'focusFilledRectangle' },
    {
      name: 'drawFilledRectangle',
      params: {
        border: {
          width: 0,
          color: '#000',
        },
        fill: {
          color: '#000000',
        },
      },
    },
  ],

  backdrop: [
    { name: 'dragBackdropItem' },
    {
      name: 'drawBackdropItem',
      params: {
        border: {
          width: 4,
          color: '#f5a623',
        },
        fill: {
          color: '#000000',
        },
      },
    },
  ],

  resize: [{ name: 'resizeItem' }, { name: 'dragItem' }, { name: 'drawResizeItem' }],

  filledLine: [
    { name: 'removeLine' },
    { name: 'dragLine' },
    { name: 'selectLine' },
    { name: 'focusLine' },
    {
      name: 'drawLine',
      params: {
        border: {
          width: 2,
          color: '#ff0000',
        },
        isNotTurnable: true,
        isLine: true,
      },
    },
  ],

  filledArrow: [
    { name: 'removeLine' },
    { name: 'dragLine' },
    { name: 'selectArrow' },
    { name: 'focusArrow' },
    {
      name: 'drawArrow',
      params: {
        border: {
          width: 2,
          color: '#ff0000',
        },
        isNotTurnable: true,
        isLine: true,
      },
    },
  ],

  text: [
    { name: 'removeText' },
    { name: 'focusCursorText' },
    { name: 'resizeText' },
    { name: 'dragText' },
    { name: 'selectText' },
    { name: 'focusText' },
    {
      name: 'drawText',
      params: {
        text: '',
        cursorPosition: 0,
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/interactionsList.js